import { ColumnDND } from '@/models/DNDOrdenation';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Text from '@/components/ui/custom/dataDisplay/Text';
import DNDOrdenationItem from './DNDOrdenationItem';
import { sortByOrder } from '@/utils/list';

interface DNDOrdenationColumnProps {
  dndOrdenationColumn: ColumnDND;
}

export default function DNDOrdenationColumn({
  dndOrdenationColumn,
}: DNDOrdenationColumnProps) {
  return (
    <div className="flex flex-col gap-3 items-center w-full">
      <ConditionalRenderer condition={!!dndOrdenationColumn.name}>
        <Text
          format="rubik-500"
          className="text-accent"
          text={dndOrdenationColumn.name}
        />
      </ConditionalRenderer>

      <div className="flex flex-col w-full gap-3">
        {sortByOrder(dndOrdenationColumn.items).map(dndOrdenationItem => {
          return (
            <DNDOrdenationItem
              key={dndOrdenationItem.id}
              dndOrdenationItem={dndOrdenationItem}
            />
          );
        })}
      </div>
    </div>
  );
}
